import { QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider, ToastViewport, TooltipProvider } from '@recipes/ui';
import { RouterProvider } from 'react-router';
import { AuthProvider } from './lib/auth/auth-provider';
import { queryClient } from './lib/query-client';
import { router } from './routes/router';
import { Toaster } from './components/feedback/toaster';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider delayDuration={300}>
          <ToastProvider swipeDirection="right">
            {/* ServiceWorkerPrompt uses router hooks, so AppShell renders it inside the router. */}
            <RouterProvider router={router} />
            <Toaster />
            <ToastViewport />
          </ToastProvider>
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
